// extracted by css-extract-rspack-plugin
export default {"skeleton":"LazyCounter-module__skeleton__L6g6T","counterLabel":"LazyCounter-module__counterLabel__ByFtT"};